export const chipsBurned = {
	byEmployee: {
		label: "Fichas queimadas por funcionário",
		sheetFileName: "fichas-queimadas-funcionario",
	},
	label: "Total de fichas queimadas",
	sheetFileName: "total-fichas-queimadas",
	since: "De",
	until: "Até",
	loading: "Gerando planilha",
	columns: {
		employee: "Funcionário",
		name: "Nome",
		product: "Produto",
		count: "Quantidade",
		unitaryCount: "Quantidade Unit.",
		fracionalCount: {
			label: "Quantidade Frac.",
			grams: "gramas",
			kg: "Kilos",
			lt: "Litros",
		},
		unitaryValue: "Valor unitário",
		subtotal: "Subtotal",
		discount: "Descontos",
		totalValue: "Total",
		type: "Tipo",
	},
	total: "TOTAL",
	totalItem: "Total",
	mountableModal: {
		name: "Nome",
		section: "Sessão Montável",
		count: "Quantidade",
	},
	mountables: {
		label: "Montaveis",
		fiscalCode: "SKU",
		product: "Produto",
		category: "Categoria Produto",
		section: "Etapa Montável",
		name: "Item Montável",
		count: "Quantidade",
	},
};
